<!-- =========================================================================================
  File Name: CustomerOrderList.vue
  Description: SCA Dashboard Item
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 22062020
========================================================================================== -->

<template>
  <div id="page-user-edit">
    <vx-card v-if="loadComplete && user_account_history">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <tab-user-order-list class="mt-4" :data="user_account_history" />
      </div>
    </vx-card>
  </div>
</template>

<script>
import TabUserOrderList     from '@/views/components/customer-tab/Tab_User_Order_List.vue'
import moduleMt4Management from '@/store/mt4-management/moduleMt4Management.js'


export default {
  components: {
    TabUserOrderList
  },
  data () {
    return {
      user_accounts: null,
      user_account_history: [],
      payload: {email: null, server: 'Real'},
      loadComplete: false
    }
  },

  methods: {
    fetch_user_dashboard (userName, server) {
      this.payload.email =  userName
      this.payload.server =  server

      this.$store.dispatch('Mt4Management/fetchUserAccountsByEmail', this.payload)
        .then(res => { 
          this.user_accounts = res.data 
          this.user_account_history = null
          if (this.user_accounts && this.user_accounts.length > 0) {
            this.user_accounts.forEach(item => {
              this.fetch_ClientHistory(item.LOGIN, '2010-01-01', '2020-10-01', 'Real')
            })
          }
        })
    },
    fetch_ClientHistory (client, start, end, server) {
      this.payload.client =  client
      this.payload.start =  start
      this.payload.end =  end
      this.payload.server =  server

      this.$store.dispatch('Mt4Management/fetchClientHistory', this.payload)
        .then(res => { 
          if (this.user_account_history) this.user_account_history = this.user_account_history.concat(res.data)
          else this.user_account_history = res.data

          if (res.data.length > 0) this.loadComplete = true

        })
    }
  },
  created () {
    if (!moduleMt4Management.isRegistered) {
      this.$store.registerModule('Mt4Management', moduleMt4Management)
      moduleMt4Management.isRegistered = true
    }

    // this.fetch_user_dashboard('info@n1cm.com', 'Real')
  }
}

</script>
